import React from 'react';
import { Stack } from '@mui/material';
import CollapseSection from '../../components/CollapseSection';
import FaviconUploader from './FaviconUploader';
import { useTranslation } from 'services/localization';

const ThemeSettings = () => {
	const { t } = useTranslation();
	return (
		<CollapseSection
			id="theme-settings-section"
			heading={t('channels.online.themeSettings.themeSettings', 'Theme settings')}
		>
			<Stack spacing={2}>
				<FaviconUploader />
			</Stack>
		</CollapseSection>
	);
};

export default ThemeSettings;
